import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IDashboardJobApi, IDashboardJobsInfoApi } from './dashboardJobsTypes';

export enum DashboardJobsStatus {
  OPEN = 'open',
  ACTION_REQUIRED = 'action-required',
  FILLED = 'filled',
}

export enum DashboardJobsType {
  ALL = 'all',
  SHIFT = 'shift',
  INTERVIEW = 'interview',
}

export interface IGetDashboardJobsParams {
  page: number;
  limit: number;
  status: DashboardJobsStatus;
  jobType?: DashboardJobsType;
}

export interface IGetDashboardJobsInfoParams {
  jobType?: DashboardJobsType;
}

async function getDashboardJobs({
  jobType = DashboardJobsType.ALL,
  limit,
  page,
  status,
}: IGetDashboardJobsParams): Promise<IDashboardJobApi[]> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IDashboardJobApi[]>(`/jobs/dashboard/${status}`, {
    headers,
    params: {
      page: page ?? 1,
      limit: limit ?? 10,
      jobType: jobType === DashboardJobsType.ALL ? undefined : jobType,
    },
  });

  return response.data;
}

async function getDashboardJobsInfo(
  params?: IGetDashboardJobsInfoParams,
): Promise<IDashboardJobsInfoApi> {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<IDashboardJobsInfoApi>(`/jobs/dashboard`, {
    headers,
    params: {
      jobType:
        params?.jobType === DashboardJobsType.ALL || !params?.jobType ? undefined : params.jobType,
    },
  });
  return response.data;
}

export const dashboardJobsApi = {
  getDashboardJobs,
  getDashboardJobsInfo,
};
